import React from 'react';
import classNames from 'classnames';

import {ErrorField} from 'components/Fields';

import './styles.css';

const TextField = ({
  input: {onBlur, onChange, value},
  placeholder,
  className,
  disabled,
  meta: {touched, error}
}: any) => {
  return (
    <div className={classNames('TextField', className)}>
      <input
        className={classNames({error: touched && error, disabled: disabled})}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        type="text"
        disabled={disabled}
      />
      <ErrorField touched={touched} error={error} />
    </div>
  );
};

export default TextField;
